export default __webpack_public_path__ + "static/media/squirrelpng.7f04865e.png";